import { render } from "./StockDashboard.vue?vue&type=template&id=32e7478c&ts=true"
import script from "./StockDashboard.vue?vue&type=script&lang=ts"
export * from "./StockDashboard.vue?vue&type=script&lang=ts"

import "./StockDashboard.vue?vue&type=style&index=0&id=32e7478c&lang=scss"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__